var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelBluesky = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.976 4.014c2.438 1.83 5.061 5.542 6.024 7.534.963-1.992 3.585-5.703 6.023-7.534 1.76-1.32 4.61-2.342 4.61.91 0 .649-.372 5.455-.59 6.235-.76 2.713-3.526 3.405-5.987 2.986 4.301.732 5.396 3.157 3.033 5.581-4.488 4.605-6.45-1.155-6.953-2.63-.092-.272-.136-.398-.136-.29 0-.108-.044.018-.136.29-.503 1.475-2.465 7.235-6.953 2.63-2.363-2.424-1.269-4.849 3.032-5.58-2.46.418-5.227-.274-5.986-2.987-.218-.78-.59-5.586-.59-6.235 0-3.252 2.85-2.23 4.61-.91z"
})));
export default SvgGemChannelBluesky;